import $ from 'jquery';
import 'daterangepicker';
import 'moment';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    format: 'DD/MM/YYYY',
    clear: 'Limpar',
    apply: 'Aplicar',
    custom: 'Custom',
    week: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    months: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
  },
  en: {
    format: 'DD/MM/YYYY',
    clear: 'Clear',
    apply: 'Apply',
    custom: 'Custom',
    week: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
  },
  es: {
    format: 'DD/MM/YYYY',
    clear: 'Limpiar',
    apply: 'Aplicar',
    custom: 'Custom',
    week: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb'],
    months: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ],
  },
};

export const dateRange = (orientation = 'down') => {
  var prev_date = new Date();

  $('.js-date').daterangepicker({
    autoUpdateInput: false,
    opens: 'center',
    drops: orientation,
    showCustomRangeLabel: false,
    locale: {
      format: tr[lang].format,
      cancelLabel: tr[lang].clear,
      applyLabel: tr[lang].apply,
      customRangeLabel: tr[lang].custom,
      daysOfWeek: tr[lang].week,
      monthNames: tr[lang].months,
    },
  });

  $('.js-date').on('apply.daterangepicker', function (ev, picker) {
    $('input[name="start_at"]').val(picker.startDate.format('DD/MM/YYYY'));
    $('input[name="end_at"]').val(picker.endDate.format('DD/MM/YYYY'));
    $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
  });

  $('.js-date').on('cancel.daterangepicker', function (ev, picker) {
    $('input[name="filter[start_at]"]').val('');
    $('input[name="filter[end_at]"]').val('');
    $(this).val('');
  });
};
